export default "__VITE_ASSET__CFY0AtZv__"